module.exports = __webpack_public_path__ + "static/media/map-food-court.9ea17a7f.png";